<template>
  <SectionBox class="mandala-goal-template-form-activity-goal-item">
    <div class="pb-2 d-flex align-items-center">
      <slot name="prependName" />
      <ChangedBox />
      <MaterialIcon
        class="mr-2"
        icon="flag" />
      <span class="mandala-goal-template-form-activity-goal-item__name font-weight-bold">
        <slot name="goalName">
          行動目標はメンバーが作成します
        </slot>
      </span>
    </div>
    <div class="mandala-goal-template-form-activity-goal-item__slider">
      <BaseSlider
        min="0"
        max="5"
        disabled />
      <div
        v-if="$scopedSlots.aboveSlider"
        class="mandala-goal-template-form-activity-goal-item__slider__above">
        <slot name="aboveSlider" />
      </div>
    </div>
  </SectionBox>
</template>

<script>
import SectionBox from '@/components/parts/SectionBox.vue'
import BaseSlider from '@/components/parts/BaseSlider.vue'
import ChangedBox from '@/components/parts/ChangedBox.vue'
export default {
  components: {
    BaseSlider,
    SectionBox,
    ChangedBox
  }
}
</script>

<style lang="scss" scoped>
.mandala-goal-template-form-activity-goal-item {
  &__name {
    font-size: 12px;
  }

  &__slider {
    position: relative;

    &__above {
      position: absolute;
      top: 30%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>